export const RESERVED_URL_KEYS = ["q", "sort"] as const;

export type ReservedUrlKey = (typeof RESERVED_URL_KEYS)[number];

export function isReservedUrlKey(key: string): key is ReservedUrlKey {
    return RESERVED_URL_KEYS.includes(
        key as (typeof RESERVED_URL_KEYS)[number]
    );
}

export function warnIfReservedKey(key: string, context: string): boolean {
    if (!isReservedUrlKey(key)) return false;
    // eslint-disable-next-line no-console
    console.warn(
        `[filterableGallery] FilterDefinition.id "${key}" collides with a reserved URL key (${context}). URL sync skipped for this filter.`
    );
    return true;
}
